import React, { Component } from 'react';
import {
    BrowserRouter as Router,
} from 'react-router-dom';
import * as Constants from '../Global/constants';
import { matchPath,withRouter } from 'react-router-dom';
import {SidebarWrapper} from './Sidebar.style';

import {getLocalStorageVariables,getThemeSettingsVariables,isEmptyVariable,
    GetSidebarMasterLink, GetSidebarTemplateLink,
    GetSidebarSettingLink,handleTokenExpiry,hasFeatureAccess,removeHtmlTags} from '../Global/commonFunctions';

let userDetails = "";
let themeSettings = getThemeSettingsVariables();
class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menus:"",
            users:"",
            company:"",
        }
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }

    componentDidMount(){
        this.getMenu();
    }

    componentDidUpdate(){
        themeSettings  = getThemeSettingsVariables();
    }
    /********************** API CALLS **********************/

    getMenu = () => {
        fetch(Constants.GetUserMenu,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({
                    menus:data.data.menus,
                    users:data.data.user,
                    company:data.data.company
                })
            }else{
                this.setState({
                    menus:"",
                    users:""
                })
            }
        });
    }

    render() {
        let fullName = userDetails.firstName+" "+userDetails.lastName
        let initialIcon = fullName.split(" ").map(name => name[0]).join('').toUpperCase();
        return(
            <Router>
                <SidebarWrapper
                    sidebarBg = {themeSettings.sidebarBg}
                    sidebarBorderRight = {themeSettings.sidebarBorderRight}
                    sidebarTextColor={themeSettings.sidebarTextColor}
                    sidebarIconColor={themeSettings.sidebarIconColor}
                    sidebarSelectedItemBg={themeSettings.sidebarSelectedItemBg}
                    sidebarSelectedItemTextColor={themeSettings.sidebarSelectedItemTextColor}
                    sidebarSelectedItemIconColor={themeSettings.sidebarSelectedItemIconColor}
                    sidebarHoverItemBg={themeSettings.sidebarHoverItemBg}
                    sidebarHoverItemTextColor={themeSettings.sidebarHoverItemTextColor}
                    sidebarHoverItemIconColor={themeSettings.sidebarHoverItemIconColor}
                    themeColor={themeSettings.themeColor}
                >
                    <div className="vertical-menu-wrapper-type1">
                        <div className="vertical-menu-content-type1">
                            <div className="verticalmenu-close">
                                <span className="material-icons">close</span>
                            </div>
                            <div className="vertical-menu-col-type1">
                                <div className="vertical-menu-profile-type1">
                                    <div className="client-profile-bg-type1">
                                        {
                                            isEmptyVariable(this.state.company?.companyLogo) &&
                                            <img className="logo-type1" src="/assets/images/client-logo.png" alt=""/>
                                        }
                                        {
                                            !isEmptyVariable(this.state.company?.companyLogo) &&
                                            <img className="logo-type1" src={Constants.ImageBaseUrl+this.state.company.companyLogo} alt=""/>
                                        }
                                        
                                        <div className="client-profile-type1">
                                            <a href={Constants.URL_PROFILE}>
                                                <h6 className="m-b-0">{isEmptyVariable(userDetails)?"":removeHtmlTags(userDetails.firstName)+" "+removeHtmlTags(userDetails.lastName)}</h6>
                                            </a>
                                        </div>
                                        {/* <span className="material-icons">person</span> <p>Profile</p></a> */}
                                    </div>
                                    {/* <a className="m-b-10" href="#">info@amssoftwares.co.in</a> */}
                                    <a href={Constants.URL_PROFILE}>
                                        {
                                            isEmptyVariable(userDetails.profilePic)
                                            ?                                 
                                            <div className="account_circle">
                                                <h6>{initialIcon}</h6>
                                            </div>
                                            :
                                            <img src={Constants.ImageBaseUrl+userDetails.profilePic} />
                                        }
                                        
                                    </a>
                                    <hr 
                                    style={{background:`rgba(${ themeSettings.sidebarDividerColor.r }, ${ themeSettings.sidebarDividerColor.g }, ${ themeSettings.sidebarDividerColor.b }, ${ themeSettings.sidebarDividerColor.a })`}}/>
                                </div>

                                <div className="vertical-menu-list-col-type1">
                                {/* <div className="vertical-menu-heading">
                                    <p className="m-b-0">Pages</p>
                                </div> */}
                                    <div className="vertical-menu-list-type1">
                                        <ul>
                                            {
                                                !isEmptyVariable(this.state.menus['Dashboard']) && this.state.menus['Dashboard'] !== "NONE" && this.state.users?.role !== "SuperAdmin" &&
                                                <li className={matchPath(this.props.history.location.pathname, { path: "/dashboard" }) ? "active" : ""}>
                                                    <a href={Constants.URL_DASHBOARD}><span className="material-icons-outlined">dashboard</span> <p>Dashboard</p></a>
                                                </li>
                                            }
                                            {
                                                ((!isEmptyVariable(this.state.menus['Plan Assignment(All)']) && this.state.menus['Plan Assignment(All)'] !== "NONE") ||
                                                (!isEmptyVariable(this.state.menus['Plan Assignment(Manager)']) && this.state.menus['Plan Assignment(Manager)'] !== "NONE") ||
                                                (!isEmptyVariable(this.state.menus['Schedule Assignment(All)']) && this.state.menus['Schedule Assignment(All)'] !== "NONE") ||
                                                (!isEmptyVariable(this.state.menus['Schedule Assignment(Manager)']) && this.state.menus['Schedule Assignment(Manager)'] !== "NONE") ||
                                                (!isEmptyVariable(this.state.menus['Follow Up Assignment']) && this.state.menus['Follow Up Assignment'] !== "NONE")) &&
                                                this.state.users?.role !== "SuperAdmin" &&
                                                <li
                                                className={matchPath(this.props.history.location.pathname, { path: ["/assignments","/scheduledassignments","/followups"] }) ? "active" : ""}>
                                                <a href={Constants.URL_SCHEDULED_ASSIGNMENTS}><span className="material-icons-outlined">emoji_objects</span> <p>Planning</p></a></li>
                                            }
                                            {
                                                (!isEmptyVariable(this.state.menus['Execute']) && this.state.menus['Execute'] !== "NONE" ||
                                                (!isEmptyVariable(this.state.menus['Follow Up Assignment']) && this.state.menus['Follow Up Assignment'] !== "NONE")) &&
                                                this.state.users?.role !== "SuperAdmin" &&
                                                <li
                                                className={matchPath(this.props.history.location.pathname, { path: ["/executeassignmentlist","/executetasklist","/observationList","/addobservation","/executefollowups"] }) ? "active" : ""}>
                                                    <a href={Constants.URL_EXECUTEASSIGNMENTS}><span className="material-icons-outlined">assignment_turned_in</span> <p>Execute</p></a></li>
                                            }
                                            {
                                                !isEmptyVariable(this.state.menus['Report']) && this.state.menus['Report'] !== "NONE" && this.state.users?.role !== "SuperAdmin" &&
                                                <li
                                                className={matchPath(this.props.history.location.pathname, { path: ["/ongoingassignmentreports","/reportdashboard" ,"/draftassignmentreports", "/completedassignmentreports", "/ongoinggeneral/", "/draftgeneral", "/finalizedgeneral", "/initdraftgeneral"] }) ? "active" : ""}>
                                                    <a href={Constants.URL_ONGOING_REPORTS}><span className="material-icons-outlined">insert_chart</span> <p>Reports</p></a>
                                                </li>
                                            }
                                            {
                                                !isEmptyVariable(this.state.menus['Task']) && this.state.menus['Task'] !== "NONE" && this.state.users?.role !== "SuperAdmin" &&
                                                <li
                                                className={matchPath(this.props.history.location.pathname, { path: ["/tasks","/addtask","/viewtasks","/edittask",
                                                "/viewfunctiontasks","/drafttasks","/underreviewtasks","/checklist"] }) ? "active" : ""}>
                                                    <a href={Constants.URL_TASKS}><span className="material-icons-outlined">task_alt</span> <p>Tasks</p></a>
                                                </li>
                                            }
                                            {
                                                !isEmptyVariable(this.state.menus['Client']) && this.state.menus['Client'] !== "NONE" &&
                                                <li
                                                    className={matchPath(this.props.history.location.pathname, { path: ["/listclients","/addclient","/editclient","/editsubscription",
                                                        "/tasktemplates","/executetasktemplates","/tasktemplatedetails","/exectasktemplatedetails","/observationtemplatedetails",
                                                        "/observationtemplates","/addexectasktemplate","/editexectasktemplate","/generaltemplates","/generaltemplatesdetails",
                                                        "/followuptemplates","/auditeecommenttemplates","/auditeecommenttemplatesdetails","/editauditeecommenttemplates","/clientdashboard","/addclientdashboard"
                                                    ] }) ? "active" : ""}>
                                                    <a href={Constants.URL_CLIENTS}><span className="material-icons-outlined">supervised_user_circle</span> <p>Clients</p></a>
                                                </li>
                                            }
                                            {
                                                this.state.users.role === "SuperAdmin" &&
                                                <li
                                                    className={matchPath(this.props.history.location.pathname, { path: ["/framework"] }) ? "active" : ""}>
                                                    <a href={Constants.URL_FRAMEWORK}><span className="material-symbols-outlined">Flowsheet</span> <p>Framework</p></a>
                                                </li>
                                            }
                                            {
                                                !isEmptyVariable(this.state.menus['Company']) && this.state.menus['Company'] !== "NONE" && this.state.users?.role !== "SuperAdmin" &&
                                                <li
                                                    className={matchPath(this.props.history.location.pathname, { path: ["/clients"] }) ? "active" : ""}>
                                                    <a href={Constants.URL_COMPANIES}><span className="material-icons-outlined">supervised_user_circle</span> <p>Clients</p></a>
                                                </li>
                                            }
                                            {
                                                this.state.users?.role === "SuperAdmin" &&
                                                <li
                                                    className={matchPath(this.props.history.location.pathname, { path: ["/cityMaster"] }) ? "active" : ""}>
                                                    <a href={Constants.URL_CITIES}><span className="material-icons-outlined">public</span> <p>City Master</p></a>
                                                </li>
                                            } 
                                            {
                                                !isEmptyVariable(this.state.menus['Units']) && this.state.menus['Units'] !== "NONE" && this.state.users?.role !== "SuperAdmin" &&
                                                <li
                                                    className={matchPath(this.props.history.location.pathname, { path: ["/units"] }) ? "active" : ""}>
                                                    <a href={Constants.URL_UNITS}><span className="material-icons-outlined">business</span> <p>Units</p></a>
                                                </li>
                                            }
                                            {
                                                !isEmptyVariable(this.state.menus['User Management']) && this.state.menus['User Management'] !== "NONE" && 
                                                <li
                                                    className={matchPath(this.props.history.location.pathname, { path: ["/users","/userroles","/adduserrole","/edituserrole","/userdepartments","/managers","/dashboardroles","/adddashboardroles","/editdashboardroles"] }) ? "active" : ""}
                                                    ><a href={Constants.URL_USERLIST}><span className="material-icons-outlined">account_box</span> <p>Users</p></a>
                                                </li>
                                            }
                                            {
                                                ((!isEmptyVariable(this.state.menus['Masters']) && this.state.menus['Masters'] !== "NONE") ||
                                                (!isEmptyVariable(this.state.menus['GeneralMasters']) && this.state.menus['GeneralMasters'] !== "NONE")) && this.state.users?.role !== "SuperAdmin" &&
                                                <li
                                                className={matchPath(this.props.history.location.pathname, { path: ["/processes","/functions","/industries","/documents","/risk","/othermasters","/generalmasters"] }) ? "active" : ""}>
                                                    <a href={GetSidebarMasterLink(this.state.menus)}><span className="material-icons-outlined">description</span>
                                                    <p>Masters</p></a>
                                                </li>
                                            }
                                            {
                                                this.state.users?.role !== "SuperAdmin" && 
                                                (hasFeatureAccess(Constants.FEATURE_STANDARD_FRAMEWORK) || hasFeatureAccess(Constants.FEATURE_INTERNAL_FRAMEWORK)) &&
                                                ((!isEmptyVariable(this.state.menus[Constants.SCREEN_INTERNAL_FRAMEWORK]) && this.state.menus[Constants.SCREEN_INTERNAL_FRAMEWORK] !== "NONE") || 
                                                (!isEmptyVariable(this.state.menus[Constants.SCREEN_STANDARD_FRAMEWORK]) && this.state.menus[Constants.SCREEN_STANDARD_FRAMEWORK] !== "NONE")) &&
                                                <li
                                                    className={matchPath(this.props.history.location.pathname, { path: ["/internal","/standard"] }) ? "active" : ""}>
                                                    <a href={(hasFeatureAccess(Constants.FEATURE_INTERNAL_FRAMEWORK) && 
                                                        (!isEmptyVariable(this.state.menus[Constants.SCREEN_INTERNAL_FRAMEWORK]) && 
                                                        this.state.menus[Constants.SCREEN_INTERNAL_FRAMEWORK] !== "NONE")) ? 
                                                        Constants.URL_INTERNAL:Constants.URL_STANDARD}
                                                    >
                                                        <span className="material-symbols-outlined">Flowsheet</span> <p>Framework</p>
                                                    </a>
                                                </li>
                                            }
                                            {/* {
                                                ((!isEmptyVariable(this.state.menus['Task Template']) && this.state.menus['Task Template'] !== "NONE") ||
                                                (!isEmptyVariable(this.state.menus['Execution Template']) && this.state.menus['Execution Template'] !== "NONE") ||
                                                (!isEmptyVariable(this.state.menus['Observation Template']) && this.state.menus['Observation Template'] !== "NONE") ||
                                                (!isEmptyVariable(this.state.menus['Follow Up Template']) && this.state.menus['Follow Up Template'] !== "NONE")) &&
                                                this.state.users?.role !== "SuperAdmin" &&
                                                <li
                                                className={matchPath(this.props.history.location.pathname, { path: ["/tasktemplates","/executetasktemplates",
                                                "/tasktemplatedetails","/exectasktemplatedetails","/observationtemplatedetails",
                                                "/observationtemplates","/addexectasktemplate","/editexectasktemplate","/generaltemplates","/generaltemplatesdetails",
                                                "/followuptemplates","/auditeecommenttemplates","/auditeecommenttemplatesdetails","/editauditeecommenttemplates"] }) ? "active" : ""}>
                                                    <a href={GetSidebarTemplateLink(this.state.menus)}><span className="material-icons-outlined">post_add</span>
                                                    <p>Templates</p></a>
                                                </li>
                                            } */}
                                            {
                                                this.state.users?.role === "SuperAdmin" &&
                                                <li
                                                    className={matchPath(this.props.history.location.pathname, { path: ["/adminSettings"] }) ? "active" : ""}>
                                                    <a href={Constants.URL_ADMIN_SETTINGS}><span className="material-icons-outlined">settings</span> <p>Settings</p></a>
                                                </li>
                                            
                                            }
                                            {
                                                ((!isEmptyVariable(this.state.menus['Department Settings']) && this.state.menus['Department Settings'] !== "NONE") || 
                                                (!isEmptyVariable(this.state.menus['Client Settings']) && this.state.menus['Client Settings'] !== "NONE"))  && 
                                                this.state.users?.role !== "SuperAdmin" &&
                                                <li
                                                    className={matchPath(this.props.history.location.pathname, { path: ["/clientsettings","/departmentsettings","/assignmenttypesettings","/templatesettings"] }) ? "active" : ""}>
                                                    <a href={GetSidebarSettingLink(this.state.menus)}><span className="material-icons-outlined">settings</span> <p>Settings</p></a></li>
                                            }
                                            <li>
                                                <a href="/logout"><span className="material-icons-outlined">exit_to_app</span> <p>Logout</p></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </SidebarWrapper>
            </Router>
        );
    }
}

export default withRouter(Sidebar);